// Volume Discount
/*---- Volume Discount MRP level discount -------*/

let volumeDiscountDiscountPercentage;
let selectedVolumeDiscountCard;
let volumeDiscountWrapper = document.querySelector(
  ".volume-discount-wrapper.selected_variant"
);

let selectedVariantVolumeDiscount =
  volumeDiscountWrapper
    ?.querySelector(".volume-discount-variant-card.active")
    ?.getAttribute("data-vd-variant-id") ?? null;

let volumeDiscountInventoryQuantities = volumeDiscountWrapper?.getAttribute(
  "data-inventory-quantity"
);

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".volume-discount-variant-card")
    ?.forEach((card) => {
      card.addEventListener("click", () => {
        clickHandlerForVolumeDiscountVariants(card);
      });
    });
});

class VolumeDiscountAddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "click",
      this.checkQuantityForVariantsVolumeDiscount.bind(this)
    );
  }

  checkQuantityForVariantsVolumeDiscount() {
    let isPincodeEntered = checkForPincode();
    if (!isPincodeEntered) {
      return;
    }
    this.showATCLoader();

    // Cache DOM elements
    const productErrorMessage = document.querySelector(
      ".ProductErrorMessageVolumeDiscount"
    );

    selectedVolumeDiscountCard = volumeDiscountWrapper?.querySelector(
      ".volume-discount-variant-card.active"
    );
    let volumeDiscountQuantity;
    if (selectedVolumeDiscountCard) {
      volumeDiscountQuantity = parseInt(
        selectedVolumeDiscountCard.getAttribute("data-vd-quantity")
      );
      volumeDiscountDiscountPercentage =
        selectedVolumeDiscountCard.getAttribute("data-vd-discount-percentage");
      selectedVariantVolumeDiscount =
        selectedVolumeDiscountCard.getAttribute("data-vd-variant-id");
    } else {
      volumeDiscountQuantity = 1;
      volumeDiscountDiscountPercentage = 0;
      selectedVolumeDiscountCard = null;
    }

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cartData) => {
        let variantStockExceeded = false;
        if (!cartData.items || !Array.isArray(cartData.items)) {
          console.error("Error: Invalid cart data structure.");
          return;
        }
        // Check each variant's quantity against inventory
        let numberOfVolumeDiscountVariants = volumeDiscountWrapper
          ?.querySelector(".volume-discount-variant-card-wrapper")
          .getAttribute("data-no-of-volume-discount-variants");

        for (let i = 0; i < parseInt(numberOfVolumeDiscountVariants); i++) {
          const cartItem = cartData.items.find(
            (item) => item.id == selectedVariantVolumeDiscount
          );
          let cartQuantity = cartData.items
            .filter((item) => item.id == selectedVariantVolumeDiscount)
            .reduce((total, item) => total + item.quantity, 0);
          if (cartItem) {
            let sum = cartQuantity + volumeDiscountQuantity;
            if (
              cartQuantity == volumeDiscountInventoryQuantities ||
              sum > volumeDiscountInventoryQuantities
            ) {
              if (productErrorMessage) {
                productErrorMessage.classList.add("tw-flex");
                productErrorMessage.classList.remove("tw-hidden");
                let difference =
                  volumeDiscountInventoryQuantities - cartQuantity;
                if (difference > 0) {
                  productErrorMessage.querySelector(
                    ".message"
                  ).innerHTML = `Only ${difference} more can be added.`;
                } else {
                  productErrorMessage.querySelector(
                    ".message"
                  ).innerHTML = `Only ${volumeDiscountInventoryQuantities} Available In Stock`;
                }
              }

              if (productErrorMessage) {
                setTimeout(() => {
                  productErrorMessage.classList.remove("tw-flex");
                  productErrorMessage.classList.add("tw-hidden");
                }, 4000);
              }
              variantStockExceeded = true;
              this.hideATCLoader();
              break;
            }
          }
        }
        if (!variantStockExceeded) {
          this.addToCart();
        }
      })
      .catch((error) => {
        console.error(
          `Failed to check variant quantity in cart: ${error.message}`
        );
        if (productErrorMessage) {
          productErrorMessage.classList.add("tw-flex");
          productErrorMessage.classList.remove("tw-hidden");
          productErrorMessage.querySelector(".message").innerHTML =
            "Failed to check variant quantity. Please try again.";
        }
        this.hideATCLoader();
      });
  }

  showATCLoader() {
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
    this.querySelector(".loading-overlay__spinner").classList.add("tw-flex");
    this.setAttribute("aria-disabled", "true");
    this.classList.add("loading");
    this.querySelector(".atc-text").classList.add("tw-hidden");
  }

  hideATCLoader() {
    this.classList.remove("active");
    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
    this.querySelector(".loading-overlay__spinner").classList.remove("tw-flex");
    this.removeAttribute("aria-disabled");
    this.classList.remove("loading");
    this.querySelector(".atc-text").classList.remove("tw-hidden");
  }

  async addToCart() {
    const cartDrawer =
      document.querySelector("cart-drawer") ||
      document.querySelector("cart-notification");
    const sectionsToRender = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);

    if (selectedVolumeDiscountCard) {
      selectedVariantVolumeDiscount =
        selectedVolumeDiscountCard.getAttribute("data-vd-variant-id");
    } else {
      selectedVariantVolumeDiscount = this.getAttribute("data-main-variant-id");
    }

    let volumeDiscountQuantity;

    if (selectedVolumeDiscountCard) {
      volumeDiscountQuantity =
        selectedVolumeDiscountCard.getAttribute("data-vd-quantity");
    } else {
      volumeDiscountQuantity = 1;
    }

    const formData = new FormData();

    formData.append("id", selectedVariantVolumeDiscount);
    formData.append("quantity", volumeDiscountQuantity);
    formData.append(
      "properties[_volumeDiscountQuantity]",
      volumeDiscountQuantity
    );
    formData.append(
      "properties[_uniqueId]",
      `${selectedVariantVolumeDiscount}_${new Date().getTime()}`
    );
    if (volumeDiscountQuantity > 1) {
      formData.append("properties[_volumeDiscountProduct]", true);
    } else {
      formData.append("properties[_volumeDiscountProduct]", false);
    }
    formData.append("sections", sectionsToRender);

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error("Failed to add product to cart");
      }

      this.hideATCLoader();
      if (cartDrawer) {
        cartDrawer.classList.remove("is-empty");
        cartDrawer.renderContents(data);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("Error while adding to cart");
      this.hideATCLoader();
    }
  }
}

customElements.define(
  "volume-discount-add-to-cart-button",
  VolumeDiscountAddToCartButton
);

function clickHandlerForVolumeDiscountVariants(card) {
  if (card.classList.contains("active")) {
    card.classList.remove("active");
  } else {
    card.classList.add("active");
  }

  document.querySelectorAll(".volume-discount-variant-card")?.forEach((el) => {
    if (
      el.getAttribute("data-vd-quantity") !=
      card.getAttribute("data-vd-quantity")
    ) {
      el.classList.remove("active");
    }
  });
}
